import React from 'react';
import { subHeading2 } from '../../../../Constants/Fonts';

// Section — shared card wrapper for every Risk Detail panel: a titled
// rp1_widget card with an optional right-aligned action node. Keeps all the
// sections visually consistent without each repeating the header markup.
//
// Props: title, count (optional — appended as "(n)"), action (node), children
export default function Section({ title, count, action, children }) {
    return (
        <div className="rp1_widget">
            <div className="rp1_widget_head">
                <h3 style={subHeading2({ margin: 0, color: 'var(--color-text-primary)' })}>
                    {title}
                </h3>
                {action}
            </div>
            {children}
        </div>
    );
}
